import { render, staticRenderFns } from "./ClientTab.vue?vue&type=template&id=d45bc8ca&scoped=true&"
import script from "./ClientTab.vue?vue&type=script&lang=js&"
export * from "./ClientTab.vue?vue&type=script&lang=js&"
import style0 from "./ClientTab.vue?vue&type=style&index=0&id=d45bc8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45bc8ca",
  null
  
)

export default component.exports